import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} FillTextProps
 */

/**
 * FillText FillText.
 * @extends {Base<FillTextProps>}
 */
export default class CountDown extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'CountDown',
    refs: ['days', 'hours', 'minutes', 'seconds'],
    options: {
      date: {
        type: String,
        default: '',
      },
    },
  };

  /**
   * Mount component
   * @returns {void}
   */
  mounted() {
    this.targetDate = new Date(`${this.$options.date}T08:00:00`);
    setInterval(() => {
      this.updateCountdown();
    }, 1000);
    this.updateCountdown();
  }

  /**
   * Update datas in countdown
   * @returns {void}
   */
  updateCountdown() {
    const currentDate = new Date();
    const timeDifference = this.targetDate - currentDate;

    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    const addZero = (number) => (number < 10 ? `0${number}` : number);

    this.$refs.days.textContent = addZero(days);
    this.$refs.hours.textContent = addZero(hours);
    this.$refs.minutes.textContent = addZero(minutes);
    this.$refs.seconds.textContent = addZero(seconds);
  }
}
